import React, { useState, useMemo } from 'react';
import { Box } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';

/**
 * LogoOrIcon
 * - Shows an <img> if `src` loads successfully
 * - Falls back to a MUI icon when missing/errored
 */
const LogoOrIcon = ({
  open,
  src,                // optional; if omitted or fails, show icon
  alt = 'Logo',
  sizeOpen = 140,      // image/icon size when drawer is open
  sizeClosed = 0,      // size when drawer is closed (kept hidden)
  IconComponent = SecurityIcon,
  iconColor = '#00E5FF',
  sx,                  // optional Box sx
}) => {
  const [errored, setErrored] = useState(false);
  const showImage = useMemo(() => Boolean(src) && !errored, [src, errored]);

  const size = open ? sizeOpen : sizeClosed;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: 2,
        ...sx,
      }}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt}
          onError={() => setErrored(true)}
          style={{
            width: size,
            height: 'auto',
            transition: 'width .28s ease',
          }}
        />
      ) : (
        <IconComponent
          sx={{
            fontSize: size > 0 ? Math.max(48, Math.min(96, size * 0.46)) : 0,
            color: iconColor,
            transition: 'font-size .28s ease',
          }}
          aria-label={alt}
        />
      )}
    </Box>
  );
};

export default LogoOrIcon;
